import { useSyncExternalStore } from 'react';
import { sessionStore } from './sessionStore';
import type { SessionState } from './sessionStore';

export function useSession(): SessionState {
  return useSyncExternalStore(sessionStore.subscribe, sessionStore.getSnapshot);
}
